<template>
	<el-dialog :visible.sync="showyubao" title="预报" width="500px" :close-on-click-modal="false" lock-scroll :modal-append-to-body="false">
		<div style="height:200px;" class="yubao">
			<table style="width:100%;">
				<tr>
					<td colspan="3" style="padding-left:20px">
						<label for>
							<el-checkbox v-model="sendremind" :true-label="1" :false-label="0" style="transform: scale(1.2);padding-top:-5px;">发送提醒</el-checkbox>
						</label>
					</td>
				</tr>
				<tr style="height:10px;">
					<td colspan="3">
						
					</td>
				</tr>
				<tr>
					<td style="width:100px">
						<label
							style="font-size:16pt;font-weight: bold;">
							用户账号
						</label>
					</td>
					<td>
						<el-autocomplete 
							:trigger-on-focus="false"
							v-model="u_account"
							ref="u_account"
							:fetch-suggestions="searchvip"
							placeholder="请输入账号\姓名"
							value-key="u_account"
							style="width:100%;font-size: 16pt; font-weight:bold;"
							@select="getuserinfo"
							@keyup.enter.native="entercontrol"
						>
							<template slot-scope="{ item }">
								<div>{{ item.u_account }} ( {{ item.u_name }} )</div>
							</template>
						</el-autocomplete>
					</td>
				</tr>
				<tr style="height:5px;">
					<td colspan="3">
						
					</td>
				</tr>
				<tr>
					<td style="width:100px">
						<label
							style="font-size:16pt;font-weight: bold;">
							单 号
						</label>
					</td>
					<td>
						<el-input style="font-size: 16pt; font-weight: 800;"
							v-model="p_pkval"
							ref="p_pkval"
							@keyup.enter.native="saveyubao"
						></el-input>
					</td>
				</tr>		
			</table>
		</div>
	</el-dialog>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	components: {},
	props: {},
	data() {
		return {
			showyubao: false,
			p_pkval:'',
			sendremind:0,
			userinfo:'',
			mode: '用户列表',
			u_account:''
		};
	},
	methods: {
		init(param) {
			this.showyubao=true;
			this.p_pkval='';
			this.sendremind=0;
			this.userinfo={};
			this.u_account='';
			var that=this;
			this.$nextTick(function() {
			if(that.$refs.u_account!=undefined)
				that.$refs.u_account.focus();
			});
		},
		entercontrol(){
			if(this.userinfo!=''){
				this.$refs.p_pkval.focus();
			}
		},
		getuserinfo(val) {
			this.userinfo = val;
			this.$refs.p_pkval.focus();
		},
		GetSearchObj() {
			var searchinfo = {
				searchbox: this.u_account.trim()
			};
			return searchinfo;
		},
		searchvip(val, cb) {
			var that = this;
			setTimeout(function() {
				if (val != '') {
					//获取会员卡列表
					var paraminfo = {
						mode: that.mode,
						tab: '',
						search: that.GetSearchObj(),
						pageindex: 0,
						pagesize: 20,
						sort: '',
						iscount: 0,
						showcol: ''
					};
					that.$apipost.get.GetGridTable({ paraminfo: paraminfo }).then(res => {
						cb(res.data);
					});
				}
			}, 300);
		},
		saveyubao(){
			var that=this;
			this.$refs.p_pkval.blur();
			if(this.p_pkval.trim()!=''){
				this.$tool.loading('正在预报', 'yubao');
				this.$apipost.post.Saveyubao({expressid:this.p_pkval.trim(),userid:this.userinfo.id}).then(res => {
					this.$tool.loadingclose();
					if(res.state=='1'){
						this.$tool.message('预报成功', 1);
						if(that.sendremind=='1')
							that.$tool.SendMessage('286-1',that._data,that);
						that.p_pkval='';
						that.$refs.p_pkval.focus();
					}else{
						this.$tool.message(res.message, 0);
					}
				});
			}
		}
	}
};
</script>

<style></style>
